import { useEffect, useState } from "react";
import cancelImg from "../assets/images/cancel.png"
import { useEditTodoMutation, useGetTodoQuery } from "../features/api/apiSlice"
const Modal = ({ setModalOn, setChoice, id }) => {

    const [editTodo, {isLoading: editLoading, isError: editError}] = useEditTodoMutation();
    const [inputText, setInputText] = useState("");
    const {data: todo, isLoading, isError} = useGetTodoQuery(id);

    useEffect(() => {
        setInputText(todo?.text)
    },[todo])
    
    const handleUpdate = () => {
        editTodo({
            id,
            data: {
                text:inputText,
            },
        });
        setChoice(true)
        setModalOn(false)
    }
    const handleCancel = () => {
        setChoice(false)
        setModalOn(false)
    }

    // decide what to render 
    let content = null;

    if(isLoading){
        content = "Loading...."
    }

    if( !isLoading && isError ) {
        content = "There was an error";
    }

    if( !isLoading && !isError && todo?.id){
        // setInputText(todo.text);
        content =  <input className="border-2" type="text" value={inputText} onChange={(e) => setInputText(e.target.value)}/>
    }

    return (

        <div className="   bg-zinc-200 opacity-90 fixed inset-0 z-50   ">

            <div className="flex h-screen justify-center items-center ">

                <div className="flex-col justify-center  bg-white py-12 px-24 border-4 border-sky-500 rounded-xl ">

                    {/* fetch todo  */}
                    <div
                        className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0"
                    >
                        <div
                            className="rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 border-green-500 focus-within:border-green-500"
                        >
                            <input
                                type="checkbox"
                                className="opacity-0 absolute rounded-full"
                            />
                            <svg
                                className="hidden fill-current w-3 h-3 text-green-500 pointer-events-none"
                                viewBox="0 0 20 20"
                            >
                                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                            </svg>
                        </div>
                        {/* line-through  */}
                        <div className="select-none flex-1">
                           {content}
                        </div>

                        


                    </div>
                    <div className="flex mt-4">
                        <button onClick={handleUpdate} className=" rounded px-4 py-2 text-white  bg-green-400 ">Update</button>
                        <button onClick={handleCancel} className="rounded px-4 py-2 ml-4 text-white bg-blue-500 ">Cancel</button>
                    </div>

                </div>
            </div>
        </div>

    );
}

export default Modal